module.exports = __webpack_public_path__ + "assets/img/m_benditong.2b59d1be.png";